import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ProjectCreateDTO, ProjectDTO} from '../../dto/project';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';

import {createProject} from '../../service/project.actions';
import {CloseableDialogComponent} from '../../../../utils/components/closeable-dialog/closeable-dialog.component';

@Component({
  selector: 'app-project-create-dialog',
  imports: [
    MatDialogActions,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    CloseableDialogComponent
],
  templateUrl: './project-create-dialog.component.html',
  styleUrl: './project-create-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCreateDialogComponent {
  private readonly dialogRef: MatDialogRef<ProjectCreateDialogComponent> = inject(MatDialogRef);
  private readonly store: Store = inject(Store);
  private readonly fb: FormBuilder = inject(FormBuilder);

  form: FormGroup = this.fb.group({
    name: ['', Validators.required],
    topic: ['', Validators.required],
  });
  project?: ProjectDTO;

  save(): void {
    if (this.form && this.form.valid) {
      const toCreate: ProjectCreateDTO = {...this.form.value};
      this.store.dispatch(createProject({project: toCreate}));
      this.dialogRef.close();
    }
  }
}
